import { create } from 'zustand'

interface AppLoadingStore {
  loading: boolean
  setLoading: (loading: boolean) => void
}

export const useAppLoadingStore = create<AppLoadingStore>((set) => ({
  loading: false,
  setLoading: (loading: boolean) => set({ loading })
}))
